/**
 * The language the customer last wrote in. The thinking line follows it, so an
 * Arabic question gets an Arabic "thinking" line even in an English widget.
 */
let last: 'ar' | 'en' | null = null

export function noteCustomerText(text: string): void {
  if (/[؀-ۿ]/.test(text)) last = 'ar'
  else if (/[A-Za-z]/.test(text)) last = 'en'
}

export function customerLang(): 'ar' | 'en' | null {
  return last
}
